import { index, show, store, update, destroy, getColumns, report } from "../../../api/excelColumns";

export const actions = {
    index({ commit }, data) {
        return new Promise((resolve, reject) => {
            index(data).then(res => {
                commit("SET_LIST", res.data.data.excel_reports);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    getColumns({ commit }, data) {
        return new Promise((resolve, reject) => {
            getColumns(data).then(res => {
                commit("SET_COLUMNS", res.data.data.columns);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    report({
        commit
    }, params = {}) {
        return new Promise((resolve, reject) => {
            report(params).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    show({ commit }, id) {
        return new Promise((resolve, reject) => {
            show(id).then(res => {
                commit("SET_MODEL",res.data.data.excel_report);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    store({ commit }, data) {
        return new Promise((resolve, reject) => {
            store(data).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    update({ commit }, data) {
        return new Promise((resolve, reject) => {
            update(data).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    destroy({ commit }, id) {
        return new Promise((resolve, reject) => {
            destroy(id).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    empty({ commit }) {
        return new Promise((resolve, reject) => {
            commit("EMPTY_MODEL");
            resolve()
        })
    },
    clearFilter({ commit }) {
        commit("CLEAR_FILTER");
    },
    updateSort({ commit }, sort) {
        commit("SET_SORT", sort)
    },

    updateFilter({ commit }, filter) {
        commit('SET_FILTER', JSON.parse(JSON.stringify(filter)))
    },

    updateColumn({ commit }, obj) {
        commit('UPDATE_COLUMN', obj)
    },

    updatePagination({ commit }, pagination) {
        commit('UPDATE_PAGINATION', pagination)
    },
    refreshData({ commit }) {
        return new Promise((resolve, reject) => {
            commit("REFRESH")
            resolve()
        })
    }
};
